import cn from "classnames";
import Image from "next/image";
import { useStore } from "@hooks/useZustandProvider";
import { useMediaQuery } from "@hooks/useMediaQuery";
import s from "./EmptyWidget.module.scss";

import gallerySvg from "@images/svg/CMS/gallery.svg";

const EmptyWidget = ({
  preview = "",
  type = "",
  lang = "",
  widgetId,
  isSmall,
  ...props
}) => {
  const { isMobile } = useMediaQuery();
  const { cms, updateWidget, toggleIsWidgetEditing } = useStore();

  const { list } = cms.widget;

  const handleClickToEdit = (e) => {
    switch (e.detail) {
      // case 1: // click
      // break;
      case 2: // double click
        updateWidget(list[widgetId]);
        toggleIsWidgetEditing();

      // break;
      // case 3: // triple click
      // break;
    }
  };

  return (
    <div
      className={cn(s.emptyWidget, isSmall && s.small)}
      onClick={handleClickToEdit}
      {...props}
    >
      {preview && (
        <div className={s.preview}>
          <Image
            src={preview}
            fill
            style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }}
            alt="galery preview"
          />
        </div>
      )}

      {(!isSmall || isMobile) && (
        <div className={s.header}>
          <div className={s.subTitle}>Widget {type.toUpperCase()}</div>
          <div className={s.title}>
            {`Widget for ${lang.toUpperCase()} not exist.`}
          </div>
        </div>
      )}

      <div className={s.subHeader}>
        <div className={s.title}>Double-click to edit widget</div>
        <div className={s.subTitle}>
          {`Widget ${type} for ${lang.toUpperCase()} language not exist. Edit the widget in the desired language`}
        </div>
      </div>
    </div>
  );
};

export default EmptyWidget;
